import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.svg';

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-company">
          <img className="footer-logo" src={logo} alt="Oneshoo" />
          <span>Oneshoo Limited</span>
          <span>
            Flat A, 15/F Hillier Comm. Bldg., 65-67 Bonham Strand East,
            Sheung Wan, Hong Kong
          </span>
          <span>Hong Kong registration number: 3227196 | Tax ID: 3227196</span>
          <span>© {new Date().getFullYear()} Oneshoo Ltd</span>
        </div>
        <nav className="footer-nav">
          <div>
            <strong>Projects</strong>
            <a href="https://farshore.netlify.app/">Farshore</a>
            <a href="https://www.youtube.com/@CoachGinge">Coach Ginge</a>
            <a href="https://www.youtube.com/@quietbambooo">Quiet Bamboo</a>
            <a href="https://www.youtube.com/@TheChinaNotSeen">The China You Haven&apos;t Seen</a>
          </div>
          <div>
            <strong>Studio</strong>
            <Link to="/blog">Blog</Link>
            <a href="/#contact">Contact us</a>
          </div>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
